import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M18 6.908h-3.006a.983.983 0 0 0-.984.984v3.45H18l-.584 3.798H14.01v6.968H9.623V15.14H6v-3.798h3.576l.047-3.606-.007-.654a3.934 3.934 0 0 1 3.934-3.974H18z"
    }, null, -1)
  ])))
}
export default { render: render }